function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { ReactEditor } from 'slate-react';
import { useCallback, useEffect } from 'react';
import { usePopper } from 'react-popper';

/**
 * Get bounding client rect by slate range
 */

var getRangeBoundingClientRect = function getRangeBoundingClientRect(editor, at) {
  if (!at) return;
  try {
    var domRange = ReactEditor.toDOMRange(editor, at);
    return domRange.getBoundingClientRect();
  } catch (err) {}
};

/**
 * Get bounding client rect of the window selection
 */
var getSelectionBoundingClientRect = function getSelectionBoundingClientRect() {
  var domSelection = window.getSelection();
  if (!domSelection || domSelection.rangeCount < 1) return;
  var domRange = domSelection.getRangeAt(0);
  return domRange.getBoundingClientRect();
};
var virtualReference = {
  getBoundingClientRect: function getBoundingClientRect() {
    return {
      top: -9999,
      left: -9999,
      bottom: 9999,
      right: 9999,
      width: 90,
      height: 10,
      x: 0,
      y: 0,
      toJSON: function toJSON() {
        return null;
      }
    };
  }
};
/**
 * TODO: duplicate
 */

var usePopperPosition = function usePopperPosition(_ref) {
  var popperElement = _ref.popperElement,
    _ref$popperContainer = _ref.popperContainer,
    popperContainer = _ref$popperContainer === void 0 ? document : _ref$popperContainer,
    _ref$popperOptions = _ref.popperOptions,
    popperOptions = _ref$popperOptions === void 0 ? {} : _ref$popperOptions,
    _ref$modifiers = _ref.modifiers,
    modifiers = _ref$modifiers === void 0 ? [] : _ref$modifiers,
    _ref$offset = _ref.offset,
    offset = _ref$offset === void 0 ? [0, 0] : _ref$offset,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'auto' : _ref$placement,
    _ref$isHidden = _ref.isHidden,
    isHidden = _ref$isHidden === void 0 ? false : _ref$isHidden,
    _ref$getBoundingClien = _ref.getBoundingClientRect,
    getBoundingClientRect = _ref$getBoundingClien === void 0 ? getSelectionBoundingClientRect : _ref$getBoundingClien;
  var popperResult = usePopper(virtualReference, popperElement, _objectSpread({
    placement: placement,
    modifiers: [
    // default modifiers to position the popper correctly
    {
      name: 'preventOverflow',
      enabled: true,
      options: {
        boundary: popperContainer
      }
    }, {
      name: 'flip',
      enabled: true,
      options: {
        padding: 8
      }
    }, {
      name: 'eventListeners',
      enabled: true,
      options: {
        scroll: !isHidden,
        resize: true
      }
    }, {
      name: 'offset',
      options: {
        offset: offset
      }
    }, {
      name: 'computeStyles',
      options: {
        gpuAcceleration: false
      }
    }].concat(_toConsumableArray(modifiers)),
    strategy: 'absolute'
  }, popperOptions));
  var update = popperResult.update,
    state = popperResult.state;
  var isReady = !isHidden && !!state;
  var styles = isReady ? popperResult.styles : _objectSpread(_objectSpread({}, popperResult.styles), {}, {
    popper: _objectSpread(_objectSpread({}, popperResult.styles.popper), {}, {
      display: 'none'
    })
  });
  var updatePosition = useCallback(function () {
    if (isHidden) return;
    if (!popperElement) return;
    virtualReference.getBoundingClientRect = getBoundingClientRect;
    update === null || update === void 0 ? void 0 : update();
  }, [getBoundingClientRect, isHidden, popperElement, update]);
  useEffect(function () {
    updatePosition();
  }, [updatePosition]);
  useEffect(function () {
    popperContainer === null || popperContainer === void 0 ? void 0 : popperContainer.addEventListener('scroll', updatePosition);
    return function () {
      return popperContainer === null || popperContainer === void 0 ? void 0 : popperContainer.removeEventListener('scroll', updatePosition);
    };
  }, [updatePosition, popperContainer]);
  return _objectSpread(_objectSpread({}, popperResult), {}, {
    update: updatePosition,
    styles: styles
  });
};
export { getRangeBoundingClientRect, getSelectionBoundingClientRect, usePopperPosition, virtualReference };